import React, { useState } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import '../styles/modal.scss';

export const SendNotificationModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    title: '',
    body: '',
    notificationType: 'for-users',
    isForOneUser: false,
    targetPhoneNumber: '',
    userFilters: {
      minTrips: '',
      maxTrips: '',
      minWarnings: '',
      maxWarnings: '',
      verified: 'any',
      startDate: '',
      endDate: '',
    },
    driverFilters: {
      state: 'any',
      vechicleType: 'any',
      minTrips: '',
      maxTrips: '',
      minWarnings: '',
      maxWarnings: '',
      verified: 'any',
      verificationStatus: 'any',
      startDate: '',
      endDate: '',
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { sendNotification } = useNotifications();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.title || formData.title.trim().length === 0) {
      setError('عنوان الإشعار مطلوب');
      return;
    }

    if (!formData.body || formData.body.trim().length === 0) {
      setError('محتوى الإشعار مطلوب');
      return;
    }

    if (formData.isForOneUser && (!formData.targetPhoneNumber || formData.targetPhoneNumber.trim().length === 0)) {
      setError('رقم الهاتف مطلوب للإرسال لمستخدم محدد');
      return;
    }

    setIsLoading(true);
    setError('');
    
    try {
      const notificationData = {
        title: formData.title.trim(),
        body: formData.body.trim(),
        notificationType: formData.notificationType,
        isForOneUser: formData.isForOneUser
      };

      if (formData.isForOneUser) {
        notificationData.targetPhoneNumber = formData.targetPhoneNumber.trim();
      } else if (formData.notificationType === 'for-users') {
        notificationData.userFilters = {
          minTrips: formData.userFilters.minTrips,
          maxTrips: formData.userFilters.maxTrips,
          minWarnings: formData.userFilters.minWarnings,
          maxWarnings: formData.userFilters.maxWarnings,
          verified: formData.userFilters.verified === 'any' ? undefined : formData.userFilters.verified === 'true',
          startDate: formData.userFilters.startDate || undefined,
          endDate: formData.userFilters.endDate || undefined,
        };
      } else {
        notificationData.driverFilters = {
          state: formData.driverFilters.state === 'any' ? undefined : formData.driverFilters.state,
          vechicleType: formData.driverFilters.vechicleType === 'any' ? undefined : formData.driverFilters.vechicleType,
          minTrips: formData.driverFilters.minTrips,
          maxTrips: formData.driverFilters.maxTrips,
          minWarnings: formData.driverFilters.minWarnings,
          maxWarnings: formData.driverFilters.maxWarnings,
          verified: formData.driverFilters.verified === 'any' ? undefined : formData.driverFilters.verified === 'true',
          verificationStatus: formData.driverFilters.verificationStatus === 'any' ? undefined : formData.driverFilters.verificationStatus,
          startDate: formData.driverFilters.startDate || undefined,
          endDate: formData.driverFilters.endDate || undefined,
        };
      }

      const result = await sendNotification(notificationData);
      if (result) {
        handleClose();
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      setError(error.message || 'حدث خطأ أثناء إرسال الإشعار');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      title: '',
      body: '',
      notificationType: 'for-users',
      isForOneUser: false,
      targetPhoneNumber: '',
      userFilters: {
        minTrips: '',
        maxTrips: '',
        minWarnings: '',
        maxWarnings: '',
        verified: 'any',
        startDate: '',
        endDate: '',
      },
      driverFilters: {
        state: 'any',
        vechicleType: 'any',
        minTrips: '',
        maxTrips: '',
        minWarnings: '',
        maxWarnings: '',
        verified: 'any',
        verificationStatus: 'any',
        startDate: '',
        endDate: '',
      },
    });
    setError('');
    onClose();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError('');
  };

  const handleNestedChange = (scope, field, value) => {
    setFormData(prev => ({
      ...prev,
      [scope]: {
        ...prev[scope],
        [field]: value,
      },
    }));
    setError('');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content notification-modal" onClick={e => e.stopPropagation()}>
        <h2 className="TXT-heading2 color-normal">إنشاء إشعار</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>عنوان الإشعار</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder="أدخل عنوان الإشعار"
              required
            />
          </div>

          <div className="input-group">
            <label>محتوى الإشعار</label>
            <textarea
              value={formData.body}
              onChange={(e) => handleChange('body', e.target.value)}
              placeholder="أدخل محتوى الإشعار"
              rows="4"
              required
            />
          </div>

          <div className="input-group">
            <label>إرسال إلى</label>
            <select
              value={formData.notificationType}
              onChange={(e) => handleChange('notificationType', e.target.value)}
            >
              <option value="for-users">المستخدمين</option>
              <option value="for-drivers">السائقين</option>
            </select>
          </div>

          <div className="input-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.isForOneUser}
                onChange={(e) => handleChange('isForOneUser', e.target.checked)}
              />
              <span>إرسال لمستخدم محدد</span>
            </label>
          </div>

          {formData.isForOneUser && (
            <div className="input-group">
              <label>رقم الهاتف</label>
              <input
                type="text"
                value={formData.targetPhoneNumber}
                onChange={(e) => handleChange('targetPhoneNumber', e.target.value)}
                placeholder="أدخل رقم الهاتف"
                required
              />
            </div>
          )}

          {!formData.isForOneUser && formData.notificationType === 'for-users' && (
            <div className="filters-grid">
              <div className="input-group">
                <label>عدد الرحلات (من)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.userFilters.minTrips}
                  onChange={(e) => handleNestedChange('userFilters', 'minTrips', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد الرحلات (إلى)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.userFilters.maxTrips}
                  onChange={(e) => handleNestedChange('userFilters', 'maxTrips', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد التحذيرات (من)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.userFilters.minWarnings}
                  onChange={(e) => handleNestedChange('userFilters', 'minWarnings', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد التحذيرات (إلى)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.userFilters.maxWarnings}
                  onChange={(e) => handleNestedChange('userFilters', 'maxWarnings', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>حالة التحقق</label>
                <select
                  value={formData.userFilters.verified}
                  onChange={(e) => handleNestedChange('userFilters', 'verified', e.target.value)}
                >
                  <option value="any">بدون تصفية</option>
                  <option value="true">موثق</option>
                  <option value="false">غير موثق</option>
                </select>
              </div>
              <div className="input-group">
                <label>تاريخ الانضمام (من)</label>
                <input
                  type="date"
                  value={formData.userFilters.startDate}
                  onChange={(e) => handleNestedChange('userFilters', 'startDate', e.target.value)}
                />
              </div>
              <div className="input-group">
                <label>تاريخ الانضمام (إلى)</label>
                <input
                  type="date"
                  value={formData.userFilters.endDate}
                  onChange={(e) => handleNestedChange('userFilters', 'endDate', e.target.value)}
                />
              </div>
            </div>
          )}

          {!formData.isForOneUser && formData.notificationType === 'for-drivers' && (
            <div className="filters-grid">
              <div className="input-group">
                <label>الحالة</label>
                <select
                  value={formData.driverFilters.state}
                  onChange={(e) => handleNestedChange('driverFilters', 'state', e.target.value)}
                >
                  <option value="any">بدون تصفية</option>
                  <option value="active">نشط</option>
                  <option value="inactive">غير نشط</option>
                  <option value="deleted">محذوف</option>
                </select>
              </div>
              <div className="input-group">
                <label>نوع المركبة</label>
                <select
                  value={formData.driverFilters.vechicleType}
                  onChange={(e) => handleNestedChange('driverFilters', 'vechicleType', e.target.value)}
                >
                  <option value="any">بدون تصفية</option>
                  <option value="ساحبة">ساحبة</option>
                  <option value="رافعة">رافعة</option>
                </select>
              </div>
              <div className="input-group">
                <label>عدد الرحلات (من)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.driverFilters.minTrips}
                  onChange={(e) => handleNestedChange('driverFilters', 'minTrips', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد الرحلات (إلى)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.driverFilters.maxTrips}
                  onChange={(e) => handleNestedChange('driverFilters', 'maxTrips', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد التحذيرات (من)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.driverFilters.minWarnings}
                  onChange={(e) => handleNestedChange('driverFilters', 'minWarnings', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>عدد التحذيرات (إلى)</label>
                <input
                  type="number"
                  min="0"
                  value={formData.driverFilters.maxWarnings}
                  onChange={(e) => handleNestedChange('driverFilters', 'maxWarnings', e.target.value)}
                  placeholder="اتركه فارغًا لتجاهل الشرط"
                />
              </div>
              <div className="input-group">
                <label>تم التحقق من الهاتف</label>
                <select
                  value={formData.driverFilters.verified}
                  onChange={(e) => handleNestedChange('driverFilters', 'verified', e.target.value)}
                >
                  <option value="any">بدون تصفية</option>
                  <option value="true">موثق</option>
                  <option value="false">غير موثق</option>
                </select>
              </div>
              <div className="input-group">
                <label>حالة التوثيق</label>
                <select
                  value={formData.driverFilters.verificationStatus}
                  onChange={(e) => handleNestedChange('driverFilters', 'verificationStatus', e.target.value)}
                >
                  <option value="any">بدون تصفية</option>
                  <option value="didnt-apply">لم يتقدم</option>
                  <option value="pending">قيد المراجعة</option>
                  <option value="rejected">مرفوض</option>
                  <option value="approved">مقبول</option>
                </select>
              </div>
              <div className="input-group">
                <label>تاريخ الانضمام (من)</label>
                <input
                  type="date"
                  value={formData.driverFilters.startDate}
                  onChange={(e) => handleNestedChange('driverFilters', 'startDate', e.target.value)}
                />
              </div>
              <div className="input-group">
                <label>تاريخ الانضمام (إلى)</label>
                <input
                  type="date"
                  value={formData.driverFilters.endDate}
                  onChange={(e) => handleNestedChange('driverFilters', 'endDate', e.target.value)}
                />
              </div>
            </div>
          )}

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button 
              type="button" 
              className="cancel-btn"
              onClick={handleClose}
              disabled={isLoading}
            >
              إلغاء
            </button>
            <button 
              type="submit"
              className="submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  جاري الإرسال...
                </>
              ) : 'إرسال'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendNotificationModal;